import { render, staticRenderFns } from "./ranking.vue?vue&type=template&id=40654b6b"
import script from "./ranking.vue?vue&type=script&lang=js"
export * from "./ranking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports